import { render, staticRenderFns } from "./StepPixel.vue?vue&type=template&id=c13c8608"
import script from "./StepPixel.vue?vue&type=script&lang=js"
export * from "./StepPixel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports